/**
 * Décision 453 — le mot de passe provisoire suggéré, celui du manuel du métier.
 *
 * Règle absolue n° 1 : la valeur ne s'écrit jamais dans le code. Le Super
 * administrateur la règle en Configuration, une par rôle tel que le créateur
 * le choisit (rôles dérivés compris), plus une entrée « Dentiste ». Vide :
 * la fenêtre garde le tirage aléatoire.
 */
import { z } from 'zod';
import { memePrestation } from '../rules/boxes.js';
import { schemaChangementMotDePasse } from './auth.js';
import { schemaCodeDeRole } from './roles.js';
/** Le dentiste est un Médecin de spécialité DENTISTE : son manuel a son propre mot de passe. */
export const CIBLE_DENTISTE = 'MEDECIN+DENTISTE';
/** Préfixe des lignes de `Parametre` qui portent une suggestion : jamais dans la liste générale. */
export const PREFIXE_MOT_DE_PASSE_SUGGERE = 'comptes.mot_de_passe_suggere.';
export const cleMotDePasseSuggere = (cible) => PREFIXE_MOT_DE_PASSE_SUGGERE + cible;
export const estCleMotDePasseSuggere = (cle) => cle.startsWith(PREFIXE_MOT_DE_PASSE_SUGGERE);
/**
 * La suggestion qui s'applique au compte : « Dentiste » si le rôle est Médecin
 * et DENTISTE sa SEULE spécialité ; sinon le rôle choisi (précision du TL, 02/11).
 */
export function cibleDeSuggestion(roleCode, specialites) {
    const [seule, ...autres] = specialites;
    return roleCode === 'MEDECIN' &&
        seule !== undefined &&
        autres.length === 0 &&
        memePrestation(seule, 'DENTISTE')
        ? CIBLE_DENTISTE
        : roleCode;
}
/** Un code de rôle, ou l'entrée Dentiste. */
export const schemaCibleSuggestion = z.union([z.literal(CIBLE_DENTISTE), schemaCodeDeRole]);
export const schemaDemandeSuggestion = z.object({ cible: schemaCibleSuggestion }).strict();
/** `null` : rien n'est réglé pour ce rôle, la fenêtre tire au hasard. */
export const schemaSuggestion = z.object({ motDePasse: z.string().nullable() });
/** Une ligne de Configuration ; `motDePasse` vide = aléatoire. */
export const schemaEntreeSuggestion = z.object({
    cible: z.string(),
    libelle: z.string(),
    motDePasse: z.string(),
});
export const schemaReglageSuggestion = z
    .object({ cible: schemaCibleSuggestion, motDePasse: z.string().max(200) })
    .strict();
/**
 * `null` si la valeur s'enregistre, sinon le message. Vide = aléatoire ; une
 * valeur suit la politique des mots de passe (12 caractères, majuscule,
 * minuscule, chiffre). Le message ne recopie jamais la valeur.
 */
export function problemeMotDePasseSuggere(valeur) {
    if (valeur === '')
        return null;
    const resultat = schemaChangementMotDePasse.shape.motDePasse.safeParse(valeur);
    return resultat.success
        ? null
        : (resultat.error.issues[0]?.message ?? 'Mot de passe trop faible.');
}
//# sourceMappingURL=mot-de-passe-suggere.js.map